export var DataZoomActiveTag;

!function(DataZoomActiveTag) {
    DataZoomActiveTag.startHandler = "startHandler", DataZoomActiveTag.endHandler = "endHandler", 
    DataZoomActiveTag.middleHandler = "middleHandler", DataZoomActiveTag.background = "background";
}(DataZoomActiveTag || (DataZoomActiveTag = {}));
//# sourceMappingURL=type.js.map